import React from 'react';
import classNames from 'classnames';
import { useTrackFocus } from '../hooks/useTrackFocus';
// import './RangePickerField.less'

interface IRangePickerFieldProps {
  show?: boolean;
  value: string;
  label?: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>;
  tabIndex?: number;
}

const getClassName = (isFocused: boolean) =>
  classNames('dpc-text-field dpc-text-input dpc-text-input-wrapper', 'dp-data-filter-field__input-input', {
    'dpc-text-input-wrapper--focused': isFocused,
  });

/**
 * Individual range picker field component.
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function RangePickerField({ label, onChange, value, onKeyDown, show = true, tabIndex }: IRangePickerFieldProps) {
  const { isFocused, focusTrackingProps } = useTrackFocus();
  const id = `range-${label}`;
  return show ? (
    <label htmlFor={id} className="dp-data-filter-field__input">
      {label && <span className="dp-data-filter-field__input-label">{label}&nbsp;</span>}
      <input
        id={id}
        className={getClassName(isFocused)}
        onChange={onChange}
        value={value}
        {...focusTrackingProps}
        onKeyDown={onKeyDown}
        tabIndex={tabIndex}
      />
    </label>
  ) : null;
}
